export default __webpack_public_path__ + "static/media/biz-mobile-bg.6a04b6a7.png";